// src/components/config/api.ts
export const API_CONFIG = {
    BASE_URL: 'https://destinyapi.xavear.de',
    BUNGIE_API_BASE_URL: 'https://www.bungie.net/Platform',
    BUNGIE_AUTH_URL: 'https://www.bungie.net/en/OAuth/Authorize',
    BUNGIE_TOKEN_URL: 'https://www.bungie.net/platform/app/oauth/token/',
    BUNGIE_CLIENT_ID: '49518', // From your Bungie Developer App
    BUNGIE_API_KEY: '464750b37a63424383e8491d6f94ef16', // From your Bungie Developer App
    REDIRECT_URI: 'https://destinyachievements.xavear.de/auth/callback', // Client-side callback URL
    ENDPOINTS: {
      // Auth endpoints
      AUTH: {
        CALLBACK: '/auth/callback',
        REFRESH_TOKEN: '/auth/refresh-token',
        LOGOUT: '/auth/logout'
      },
      // Bungie API endpoints
      BUNGIE: {
        USER_INFO: '/User/GetCurrentBungieNetUser/',
        DESTINY_PROFILE: '/Destiny2/{membershipType}/Profile/{destinyMembershipId}/',
        DESTINY_CHARACTERS: '/Destiny2/{membershipType}/Profile/{destinyMembershipId}/?components=200',
        DESTINY_RECORDS: '/Destiny2/{membershipType}/Profile/{destinyMembershipId}/?components=900'
      }
    }
};